import { render, staticRenderFns } from "./commissionRuleDetail.vue?vue&type=template&id=04630f47"
import script from "./commissionRuleDetail.vue?vue&type=script&lang=js"
export * from "./commissionRuleDetail.vue?vue&type=script&lang=js"
import style0 from "./commissionRuleDetail.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports